import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import store, { RootState } from "./store/store";
import { gameActions } from "./components/Game/gameSlice";
import Game from "./components/Game/Game";
import Version from "./components/Game/Version";
import Matchmaking from "./components/Matchmaking/Matchmaking";
import { LocalStorageKeys } from "./models/LocalStorageKeys";
import NewPlayerForm from "./components/User/NewPlayerForm";
import CardPreview from "./components/Card/CardPreview";
import UserSettings from "./components/User/UserSettings";
import GameId from "./components/Game/GameId";
import PlayerStats from "./components/User/PlayerStats";
import ResetTokenForm from "./components/User/ResetTokenForm";
import About from "./components/About/About";
import { useAppSelector } from "./hooks/redux";

function App() {

    useEffect(() => {
        store.dispatch(gameActions.startConnecting());
    }, []);

    const navigate = useNavigate();
    const hasToken = !!localStorage.getItem(LocalStorageKeys.TOKEN_KEY);
    const gameState = useAppSelector((state: RootState) => state.game);

    useEffect(() => { 
        if (hasToken && !gameState.token && gameState.isWrongToken) {
            if (window.location.pathname === '/new') {
                window.location.reload();
            } else {
                navigate('/new', { replace: true });
            }
        }
    }, [hasToken, navigate, gameState.token, gameState.isWrongToken]);

    return <>
        <Routes>
            {/* <Route path="/" element={<Logo />} /> */}
            <Route path="/" element={<About />} />
            <Route path="/about" element={<About />} />
            <Route path="/matchmaking" element={<Matchmaking />} />
            <Route path="/settings" element={<UserSettings />} />
            <Route path="/stats" element={<PlayerStats />} />
            <Route path="/new" element={<NewPlayerForm />} />
            <Route path="/reset" element={<ResetTokenForm />} />
            <Route path="/new/:gameId" element={<NewPlayerForm />} />
            <Route path="/:gameId" element={<Game />} />
            <Route path="/:gameId/:secondParam" element={<Game />} />
        </Routes>
        <CardPreview />
        <Version />
        <GameId />
    </>

}

export default App;
